import React, { useState, useEffect } from 'react';
import Header from '../../layouts/Header';
import { Button, Col, Dropdown, Form, FormControl, InputGroup, Modal, Row, Spinner } from 'react-bootstrap';
import ReusableTable from '../../components/ReusableTable';
import { toast } from 'react-toastify';
import axios from '../../api/axios';
import makeAnimated from "react-select/animated";
import Select from "react-select";
import { useSelector } from 'react-redux';
import { Search } from 'react-bootstrap-icons';

const PopupAdvertisement = () => {

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [addAccess, setAddAccess] = useState([]);

    console.log("Access :", access);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("PopupAdvertisement:")
            );
            setAddAccess(filteredAccess);
        }
    }, [access]);

    console.log("Menu Access:", addAccess);

    const accessToken = localStorage.getItem("authToken");
    const animatedComponents = makeAnimated();
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openImageModal, setOpenImageModal] = useState(false);
    const [openImageUploadModal, setOpenImageUploadModal] = useState(false)
    const [searchText, setSearchText] = useState('');
    const [popUpData, setPopUpData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputData, setInputData] = useState({
        title: '',
        isSubscriptionAd: false,
        redirectTo: ''
    });
    const [editedData, setEditedData] = useState({});
    const [selectedExcludedOutlets, setSelectedExcludedOutlets] = useState([]);
    const [selectedEditedExcludedOutlets, setSelectedEditedExcludedOutlets] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState('');
    const [selectedEditProduct, setSelectedEditProduct] = useState('');
    const [outlets, setOutlets] = useState([]);
    const [productsList, setProductsList] = useState([]);
    const [image, setImage] = useState(null);
    const [editImage, setEditImage] = useState(null);
    const [isAddBtnLoading, setIsAddBtnLoading] = useState(false);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [isImageEditBtnLoading, setIsImageEditBtnLoading] = useState(false);
    const [advertisementId, setAdvertisementId] = useState('');
    const [selectedImage, setSelectedImage] = useState(null);
    const [editImageId, setEditImageId] = useState('');
    const [pagination, setPagination] = useState({ page: 1, rowsPerPage: 10 });
    const [searchTerm, setSearchTerm] = useState('');

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: "6px",
            minWidth: "200px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
        }),
    };

    const columns = [
        { header: "Sr.No", accessor: "serialNumber" },
        {
            header: "Title",
            accessor: "title",
            render: (value, row) => (
                <div className="d-flex flex-column align-items-center gap-1">
                    <span className='fw-semibold fs-6' style={{ color: 'purple' }}>{row?.title}</span>
                    <span className="text-secondary" style={{ fontSize: '12px' }}>
                        {row.createdAt
                            ? new Date(row.createdAt).toLocaleString("en-US", {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                            })
                            : "--------"
                        }
                    </span>
                    {/* <span className={`badge ${row.isSubscriptionAd ? 'bg-success' : 'bg-primary'}`}>
                        {row.isSubscriptionAd ? "Subscription Ad" : "Product Ad"}
                    </span> */}
                    <span className={`w-75 badge ${row.redirectTo === 'PRODUCT' ? 'bg-success' : row?.redirectTo === 'MENU' ? 'bg-primary' : row?.redirectTo === 'SUBSCRIPTION' ? 'bg-warning' : 'bg-secondary'}`}>
                        {row.redirectTo === "PRODUCT" ? "PRODUCT_SCREEN" : row.redirectTo === "MENU" ? "MENU_SCREEN" : row.redirectTo === "SUBSCRIPTION" ? "SUBSCRIPTION_SCREEN" : "PROFILE_SCREEN"}
                    </span>
                </div>
            ),
        },
        {
            header: "Image", accessor: "phone",
            render: (value, row) => (
                <div className="d-flex flex-column align-items-center gap-2">
                    <img
                        className="fs-7"
                        style={{
                            // width: "70px",
                            height: "80px",
                            borderRadius: "50%",
                            // marginTop: "8px",
                            // marginBottom: "8px",
                            border: "0.2px solid bluevoilet",
                            cursor: "pointer",
                        }}
                        src={row?.advertisementImage || "/dummy-image.png"}
                        alt="category-image"
                        onClick={() => handleImageClick(row)}
                    />
                </div>
            )
        },
        {
            header: "Product Name",
            accessor: "city",
            render: (value, row) => (
                <div>
                    <h6 className="mb-0">{row?.productId?.name ? row?.productId?.name : "--------"}</h6>
                </div>
            ),
        },
        {
            header: "Excluded Outlets",
            accessor: "state",
            render: (value, row) => (
                <div>
                    <div>Excluded Outlets : {" "}
                        {row.excludedOutlets && row.excludedOutlets.length > 0
                            ? row.excludedOutlets.map(outlet => outlet.name.toLowerCase().trim()).join(', ')
                            : "No outlets excluded"}
                    </div>
                </div>
            ),
        },
        {
            header: "Status",
            accessor: "status",
            render: (value, row) => (
                <span
                    className={`badge ${row?.isActive === true
                        ? "bg-success"
                        : row?.isActive === false
                            ? "bg-danger"
                            : "bg-warning"
                        }`}
                >
                    {row?.isActive === true ? "ACTIVE" : "INACTIVE"}
                </span>
            ),
        },
        {
            header: "Actions",
            accessor: null,
            render: (_, row) => (
                <div className="d-flex justify-content-center">
                    <Dropdown>
                        <Dropdown.Toggle variant="link" className="p-0 m-0 border-0">
                            <i className="ri-more-2-fill" style={{ cursor: "pointer" }}></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                            {(addAccess?.includes("PopupAdvertisement:update") || email === "contact@xpansecafe.com") && (
                                <Dropdown.Item
                                    className="text-primary"
                                    onClick={() => handleOpenEditModal(row)}
                                >
                                    Edit
                                </Dropdown.Item>
                            )}
                            {(addAccess?.includes("PopupAdvertisement:get") || email === "contact@xpansecafe.com") && (
                                <Dropdown.Item
                                    className="text-success"
                                    onClick={() => handleOpenViewModal(row)}
                                >
                                    View
                                </Dropdown.Item>
                            )}
                            {(addAccess?.includes("PopupAdvertisement:delete") || email === "contact@xpansecafe.com") && (
                                <Dropdown.Item
                                    className="text-danger"
                                    onClick={() => handleOpenDeleteModal(row)}
                                >
                                    Delete
                                </Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            ),
        },
    ];

    const outletData = outlets?.map((outlet) => ({
        value: outlet._id,
        label: `${outlet.name} (${outlet.city})`,
    }));

    const getInAppAddvertisement = async () => {
        setLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            const response = await axios.get("in-app-advertisement", { headers });
            console.log("Adverstise ment data :", response?.data?.data);
            response?.data?.data?.inAppAdvertisement?.forEach((item, index) => {
                item.serialNumber = index + 1;
            });
            let list = response?.data?.data?.inAppAdvertisement;

            let newList = list.reverse();

            setPopUpData(newList);
            setFilteredData(newList);
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const getOutlets = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("outlet", { headers });

            if (response?.data?.status === true) {

                let filteredOutlets = response?.data?.data?.outlets?.filter((act) => act?.status === "ACTIVE");

                setOutlets(filteredOutlets);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getProductsList = async (id) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("product", { headers });
            if (response?.data?.status === true) {
                console.log("Product Response :", response?.data?.data?.products);
                setProductsList(response?.data?.data?.products);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
    }

    const handleCloseAddModal = () => {
        setOpenAddModal(false);
        setSelectedProduct('');
        setSelectedExcludedOutlets([]);
        setInputData({
            title: "",
            redirectTo: "",
            isSubscriptionAd: false,
        });
        setImage(null);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputData((prevData) => ({ ...prevData, [name]: value }));
    }

    const handleImageChange = (e) => {
        console.log("HE;ll;o");
        
        const allowedExtensions = ["png", "jpg", "jpeg", "webp", "gif", "PNG", "JPG", "JPEG", "WEBP", "GIF"];
        console.log("Images :", e.target.files);
        
        const selectedImage = e.target.files[0];
        console.log("Selected IMage :", selectedImage);

        if (selectedImage) {
            const extension = selectedImage.name.split(".").pop().toLowerCase();
            if (!allowedExtensions.includes(extension)) {
                toast.error("Invalid file format. Upload only jpg or png.", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                return;
            } else {
                setImage(selectedImage);
            }
        }
    };

    const handleSelectChange = (selected) => {
        setSelectedExcludedOutlets(selected);
    };

    const handleSelectProductChange = (selected) => {
        setSelectedProduct(selected);
    };

    const handleSubmit = async (e) => {
        setIsAddBtnLoading(true);
        e.preventDefault();
        console.log("Image in Submit :", image);
        
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'multipart/form-data'
            }
            const formData = new FormData();
            console.log("Input Data :", inputData);

            let selectedOutlets = selectedExcludedOutlets?.map((out) => out?.value);

            let newInputData = {
                ...inputData,
                excludedOutlets: selectedOutlets,
                productId: selectedProduct?.value
            }

            formData.append('title', newInputData.title);
            formData.append(
                'isSubscriptionAd',
                newInputData.isSubscriptionAd ? 'true' : 'false'
            );
            // formData.append('isSubscriptionAd', newInputData.isSubscriptionAd);
            if (newInputData.productId) {
                formData.append('productId', newInputData.productId);
            }
            // else {
            //     formData.append('productId', null);
            // }
            formData.append('advertisementImage', image);
            formData.append('redirectTo', newInputData?.redirectTo);

            // Append each excluded outlet as excludedOutlets[0], excludedOutlets[1], etc.
            if (selectedOutlets?.length > 0) {
                selectedOutlets?.forEach((outlet, index) => {
                    formData.append(`excludedOutlets[${index}]`, outlet);
                });
            }

            const response = await axios.post('in-app-advertisement', formData, { 
                headers
            });
            console.log("Response :", response);
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                e.target.reset();
                getInAppAddvertisement();
                setSelectedProduct('');
                setSelectedExcludedOutlets([]);
                setInputData({
                    title: "",
                    redirectTo: "",
                    isSubscriptionAd: false
                });
                setImage(null);
                setOpenAddModal(false);
            }

        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (
                    error.response?.status === 406
                ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if (
                    error.response?.status === 412
                ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                } else if (error?.response?.status === 404) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsAddBtnLoading(false);
        }
    };

    const handleOpenEditModal = (data) => {
        console.log("Data :", data);
        setOpenEditModal(true);
        setEditedData({
            title: data?.title,
            isActive: data?.isActive,
            isSubscriptionAd: data?.isSubscriptionAd,
            redirectTo: data?.redirectTo,
            _id: data?._id
        })
        // Ensure selectedEditProduct is in { value, label } format
        setSelectedEditProduct(
            data?.productId ? { value: data.productId._id, label: data.productId.name } : null
        );
        let selectedExOutlet = data?.excludedOutlets;
        let mappedSelectedExOutlet = selectedExOutlet?.map((m) =>
        ({
            value: m?._id,
            label: m?.name
        }))
        setSelectedEditedExcludedOutlets(mappedSelectedExOutlet);
    };

    const handleCloseEditModal = () => {
        setOpenEditModal(false);
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditedData((prevData) => ({ ...prevData, [name]: value }))
    };

    const handleEditSelectChange = (selected) => {
        setSelectedEditedExcludedOutlets(selected);
    };

    const handleEditSelectProductChange = (selected) => {
        setSelectedEditProduct(selected);
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            const selectedEditOutlets = selectedEditedExcludedOutlets?.map((out) => out?.value) || [];

            let newEditedData = {
                ...editedData,
                excludedOutlets: selectedEditOutlets.length > 0 ? selectedEditOutlets : null,
                productId: selectedEditProduct?.value
            }

            const formData = new FormData();
            formData.append('_id', newEditedData._id);
            formData.append('title', newEditedData.title);
            formData.append('isActive', newEditedData.isActive);
            formData.append('redirectTo', newEditedData.redirectTo);
            if (newEditedData.productId) {
                formData.append('productId', newEditedData.productId);
            } else {
                formData.append('productId', null);
            }
            formData.append('isSubscriptionAd', newEditedData.isSubscriptionAd);

            // Handle excluded outlets
            if (selectedEditOutlets.length > 0) {
                selectedEditOutlets.forEach((outlet, index) => {
                    formData.append(`excludedOutlets[${index}]`, outlet);
                });
            } else {
                formData.append('excludedOutlets', 'null'); // Send null if no outlets
            }

            const response = await axios.put('in-app-advertisement', formData, { headers }); // Note: changed from newEditedData to formData
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                getInAppAddvertisement();
                setOpenEditModal(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                }
                else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setIsEditBtnLoading(false);
        }
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const handleImageClick = (data) => {
        setOpenImageModal(true);
        setSelectedImage(data);
    };

    const handleCloseImageModal = () => {
        setOpenImageModal(false);
    };

    const handleImageUploadModal = (data) => {
        setEditImage(data?.advertisementImage);
        setEditImageId(data?._id);
        setOpenImageUploadModal(true);
        setOpenImageModal(false);
    };

    const handleEditImageChange = (e) => {
        const allowedExtensions = ["png", "jpg", "jpeg"];
        const selectedImage = e.target.files[0];

        if (selectedImage) {
            const extension = selectedImage.name.split(".").pop().toLowerCase();
            if (!allowedExtensions.includes(extension)) {
                toast.error("Invalid file format. Upload only jpg or png.", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                return;
            } else {
                setEditImage(selectedImage);
            }
        }
    };

    const handleEditImage = async (e) => {
        e.preventDefault();
        setIsImageEditBtnLoading(true);
        try {
            const formData = new FormData();
            formData.append("advertisementImage", editImage);
            formData.append("_id", editImageId);

            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`,
            };

            const response = await axios.put(
                "in-app-advertisement",
                formData,
                { headers }
            );

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getInAppAddvertisement();
                setOpenImageUploadModal(false);
            }
        } catch (error) {
            if (error?.response?.status === 404) {
                toast.error(error.response.data.error, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response?.data?.data?.message;

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsImageEditBtnLoading(false);
        }
    };

    const handleOpenViewModal = (data) => {

    };

    const handleOpenDeleteModal = (data) => {
        setOpenDeleteModal(true);
        setAdvertisementId(data?._id);
    };

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    };

    const handleDeletePopup = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const response = await axios.delete(`in-app-advertisement?_id=${advertisementId}`, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                getInAppAddvertisement();
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error.response.status === 403) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }

            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    const handlePageChange = (page) => {
        setPagination({ ...pagination, page });
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        setPagination({ page: 1, rowsPerPage }); // Reset to the first page when changing rows per page
    };

    // Function to get paginated data
    const getPaginatedData = () => {
        const startIndex = (pagination?.page - 1) * pagination?.rowsPerPage;
        const endIndex = startIndex + pagination?.rowsPerPage;
        return filteredData?.slice(startIndex, endIndex);
    };

    const handleSubmitSearch = () => {
        const lowerSearch = searchText.toLowerCase();
        const result = popUpData?.filter((item) => {
            return (
                item?.title?.toLowerCase()?.includes(lowerSearch) ||
                item?.productId?.name?.toLowerCase()?.includes(lowerSearch)
            );
        });
        setFilteredData(result);
    }

    useEffect(() => {
        getInAppAddvertisement();
        getOutlets();
        getProductsList();
    }, []);

    useEffect(() => {
        if (!searchText) {
            setFilteredData(popUpData);
            return;
        }

        const lowerSearch = searchText.toLowerCase();

        const result = popUpData?.filter((item) => {
            return (
                item?.title?.toLowerCase()?.includes(lowerSearch) ||
                item?.productId?.name?.toLowerCase()?.includes(lowerSearch)
            );
        });

        setFilteredData(result);
    }, [searchText, popUpData]);


    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div
                    className="container shadow-sm"
                    style={{ backgroundColor: "white" }}
                >
                    <Row className="pt-4">
                        <Col>
                            <h5 className="fw-semibold">POPUP ADVERTISEMENT MANAGEMENT</h5>
                        </Col>
                        <hr />
                    </Row>

                    <Row className="mb-3">
                        <Col lg="4">
                            <Form.Group>
                                <Form.Label className="fw-semibold">
                                    Search Popup Advertisement
                                </Form.Label>
                                <InputGroup>
                                    <FormControl
                                        placeholder="Search by level name or reward type..."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                    />
                                    <Button variant="outline-primary" onClick={handleSubmitSearch}>
                                        <Search /> Search
                                    </Button>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col lg="1" className="d-flex justify-content-end flex-column"> </Col>
                        <Col>
                            {/* <div>
                                <Form.Label className="text-white">.</Form.Label>
                            </div>
                            <div className="input-group w-100">
                                <input
                                    type="text"
                                    value={searchText}
                                    onChange={handleSearchChange}
                                    className="form-control"
                                    placeholder="Search for outlets..."
                                />
                                <button className="btn btn-primary" type="button">
                                    <i className="ri-search-line"></i>
                                </button>
                            </div> */}
                        </Col>
                        <Col lg="3" className="d-flex justify-content-end flex-column">
                            {/* <Form.Label className="text-white">.</Form.Label> */}
                            {(addAccess?.includes("PopupAdvertisement:add") || email === "contact@xpansecafe.com") && (
                                <Button
                                    variant="primary"
                                    className="fw-semibold"
                                    onClick={handleOpenAddModal}
                                >
                                    <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
                                    Add New Popup Advertisement
                                </Button>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {(addAccess?.includes("PopupAdvertisement:get") || email === "contact@xpansecafe.com") && (
                                <ReusableTable
                                    columns={columns}
                                    data={getPaginatedData()}
                                    rowKey="serialNumber"
                                    loading={loading}
                                    currentPage={pagination.page}
                                    recordsPerPage={pagination.rowsPerPage}
                                    onPageChange={handlePageChange}
                                    totalPages={Math.ceil(filteredData.length / pagination.rowsPerPage)}
                                    onRecordsPerPageChange={handleRowsPerPageChange}
                                />
                            )}
                        </Col>
                    </Row>

                    {openAddModal && (
                        <Modal
                            show={openAddModal}
                            onHide={handleCloseAddModal}
                            size="lg"
                            centered
                            aria-labelledby="vertically-centered-modal"
                            backdrop="static"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="vertically-centered-modal">ADD POP-UP ADVERTISEMENT</Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleSubmit}>
                                <Modal.Body>
                                    <Row className="mb-3">
                                        <Col md={6}>
                                            <Form.Group controlId="popupTitle">
                                                <Form.Label className="fw-semibold">
                                                    Pop-Up Title <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Pop-up Title"
                                                    name="title"
                                                    value={inputData.title}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6} lg={6}>
                                            <Form.Group>
                                                <Form.Label className='fw-semibold'>
                                                    Take to <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    name="redirectTo"
                                                    value={inputData.redirectTo || ""}
                                                    onChange={handleChange}
                                                >
                                                    <option value="" disabled>Select</option>
                                                    <option value="SUBSCRIPTION">SUBSCRIPTION_SCREEN</option>
                                                    <option value="PRODUCT">PRODUCT_SCREEN</option>
                                                    <option value="MENU">MENU_SCREEN</option>
                                                    <option value="PROFILE">PROFILE_SCREEN</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={6} lg={6}>
                                            <Form.Group>
                                                <Form.Label className='fw-semibold'>
                                                    Make This Subsrciption Add <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    name="isSubscriptionAd"
                                                    value={inputData.isSubscriptionAd}
                                                    onChange={handleChange}
                                                    disabled={inputData?.redirectTo !== "SUBSCRIPTION"}
                                                >
                                                    <option value="" disabled>Select</option>
                                                    <option value="true">Yes</option>
                                                    <option value="false">No</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="selectMenu">
                                                <Form.Label className="fw-semibold">
                                                    Select Menu <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Select
                                                    options={productsList?.map((rm) => ({
                                                        value: rm?._id,
                                                        label: rm?.name,
                                                    }))}
                                                    isDisabled={inputData.isSubscriptionAd === true}
                                                    name="productId"
                                                    value={selectedProduct}
                                                    onChange={handleSelectProductChange}
                                                    classNamePrefix="react-select"
                                                    isClearable
                                                    placeholder="Select Menu"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className='mt-3'>
                                        <Col md={6}>
                                            <Form.Group controlId="popupImage">
                                                <Form.Label className="fw-semibold">
                                                    Choose Image <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="file"
                                                    onChange={handleImageChange}
                                                    accept="image/*"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="excludedOutlets">
                                                <Form.Label className="fw-semibold">
                                                    Select Excluded Outlets
                                                </Form.Label>
                                                <Select
                                                    isMulti
                                                    components={animatedComponents}
                                                    value={selectedExcludedOutlets}
                                                    onChange={handleSelectChange}
                                                    options={outletData}
                                                    styles={customStyles}
                                                    placeholder="Select Excluded Outlets"
                                                    closeMenuOnSelect={false}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 0,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#e9ecef",
                                                            primary: "#007bff",
                                                        },
                                                    })}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="primary" className="fw-semibold" type='submit'>
                                        {isAddBtnLoading ? <Spinner size='sm' /> : 'ADD POPUP ADVERTISEMENT'}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    )}

                    {openEditModal && (
                        <Modal
                            show={openEditModal}
                            onHide={handleCloseEditModal}
                            size="lg"
                            centered
                            aria-labelledby="edit-popup-modal"
                            backdrop="static"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>UPDATE POP-UP ADVERTISEMENT</Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleEditSubmit}>
                                <Modal.Body>
                                    <Row className="mb-3">
                                        <Col md={6}>
                                            <Form.Group controlId="editPopupTitle">
                                                <Form.Label className="fw-semibold">
                                                    Pop-Up Title <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Pop-up Title"
                                                    name="title"
                                                    value={editedData.title}
                                                    onChange={handleEditChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="editSelectMenu">
                                                <Form.Label className="fw-semibold">
                                                    Select Menu <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Select
                                                    options={productsList?.map((rm) => ({
                                                        value: rm?._id,
                                                        label: rm?.name,
                                                    }))}
                                                    name="productId"
                                                    value={selectedEditProduct}
                                                    onChange={handleEditSelectProductChange}
                                                    classNamePrefix="react-select"
                                                    isClearable
                                                    placeholder="Select Menu"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Col md={6} lg={6}>
                                            <Form.Group>
                                                <Form.Label className='fw-semibold'>
                                                    Take to <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    name="redirectTo"
                                                    value={editedData.redirectTo || ""}
                                                    onChange={handleEditChange}
                                                >
                                                    <option value="" disabled>Select</option>
                                                    <option value="SUBSCRIPTION">SUBSCRIPTION_SCREEN</option>
                                                    <option value="PRODUCT">PRODUCT_SCREEN</option>
                                                    <option value="MENU">MENU_SCREEN</option>
                                                    <option value="PROFILE">PROFILE_SCREEN</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6} lg={6}>
                                            <Form.Group>
                                                <Form.Label className='fw-semibold'>
                                                    Make This Subsrciption Add <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    name="isSubscriptionAd"
                                                    value={editedData.isSubscriptionAd}
                                                    onChange={handleEditChange}
                                                >
                                                    <option value="" disabled>Select</option>
                                                    <option value="true">Yes</option>
                                                    <option value="false">No</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>

                                    </Row>
                                    <Row className='mt-3'>
                                        <Col md={6}>
                                            <Form.Group controlId="editExcludedOutlets">
                                                <Form.Label className="fw-semibold">
                                                    Select Excluded Outlets
                                                </Form.Label>
                                                <Select
                                                    isMulti
                                                    components={animatedComponents}
                                                    value={selectedEditedExcludedOutlets}
                                                    onChange={handleEditSelectChange}
                                                    options={outletData}
                                                    styles={customStyles}
                                                    placeholder="Select Excluded Outlets"
                                                    closeMenuOnSelect={false}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 0,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#e9ecef",
                                                            primary: "#007bff",
                                                        },
                                                    })}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="editPopupStatus">
                                                <Form.Label className="fw-semibold">
                                                    Select Status <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    onChange={handleEditChange}
                                                    name="isActive"
                                                    value={editedData?.isActive}
                                                >
                                                    <option value="">Select Status</option>
                                                    <option value="true">ACTIVE</option>
                                                    <option value="false">INACTIVE</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="primary" className="fw-semibold" type='submit'>
                                        {isEditBtnLoading ? <Spinner size='sm' /> : 'EDIT POPUP ADVERTISEMENT'}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    )}

                    {openDeleteModal ? (
                        <Modal show={openDeleteModal} onHide={handleCloseDeleteModal} backdrop="static" centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Confirm Delete</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                Are you sure you want to delete this popup advertisement? This action cannot be undone.
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setOpenDeleteModal(false)}>
                                    Cancel
                                </Button>
                                <Button variant="danger" onClick={handleDeletePopup}>
                                    {isDeleteBtnLoading ?
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        /> :
                                        "Delete Advertisement"
                                    }
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    ) : null}

                    {openImageModal && (
                        <Modal show={openImageModal} onHide={handleCloseImageModal} backdrop="static" centered>
                            <Modal.Header closeButton style={{ backgroundColor: "#F5F5F5" }}>
                                <Modal.Title>Image Preview</Modal.Title>
                            </Modal.Header>
                            <Modal.Body >
                                {selectedImage ? (
                                    <>
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <img
                                                src={selectedImage?.advertisementImage}
                                                alt="preview"
                                                className="img-fluid"
                                                style={{ maxHeight: "60vh" }}
                                            />
                                        </div>

                                        <hr className="my-2" />
                                        <Button
                                            variant="primary"
                                            className="mt-2 text-start"
                                            onClick={() =>
                                                handleImageUploadModal({
                                                    advertisementImage: selectedImage?.advertisementImage,
                                                    _id: selectedImage?._id,
                                                })
                                            }
                                        >
                                            Change Image
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <p>No Image Available. Upload a Picture.</p>
                                        <Button variant="primary" className="rounded-pill mt-2">
                                            Upload Image
                                        </Button>
                                    </>
                                )}
                            </Modal.Body>
                        </Modal>
                    )}

                    {openImageUploadModal && (
                        <Modal
                            show={openImageUploadModal}
                            onHide={() => setOpenImageUploadModal(false)}
                            centered
                            backdrop="statics"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title className="fs-6">UPDATE IMAGE</Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleEditImage}>
                                <Modal.Body>
                                    <Form.Group controlId="formFileUpload">
                                        <Form.Label>
                                            Choose File <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="file"
                                            onChange={handleEditImageChange}
                                            required
                                        />
                                    </Form.Group>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant='primary' type='submit'>
                                        {isImageEditBtnLoading ? <Spinner size='sm' /> : "SAVE CHANGES"}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    )}
                </div>
            </div>
        </React.Fragment>
    )
}

export default PopupAdvertisement